import { useQuery } from '@tanstack/react-query';
import type { HubVersionResponse } from '@verybigthings/trackframe-shared/schemas';
import { hub } from '@/lib/hub-client';

/**
 * HUB-110 — the sidebar label for the hub's own release: `v2026.9.3`, else the
 * short commit of an untagged build, else `dev` (a hub built without release
 * info). Empty until the hub has answered.
 */
export function formatHubVersion(info: HubVersionResponse | undefined): string {
  if (!info) return '';
  if (info.version) return `v${info.version}`;
  if (info.commit) return info.commit.slice(0, 7);
  return 'dev';
}

/** The hub's release label. It never changes while the page is open. */
export function useHubVersionLabel(): string {
  const { data } = useQuery({ queryKey: ['hub-version'], queryFn: () => hub.hubVersion(), staleTime: Infinity });
  return formatHubVersion(data);
}
